import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = (pFile) => {
  const formData = new FormData()
  formData.append('fileCSV', pFile)
  return http
    .post('/v2/stock/upload-from-csv', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/view/record/stock/components/new-stock/form-file-input/FileHandle.js